import { render, staticRenderFns } from "./RuglCardInfo.vue?vue&type=template&id=4db4ae29&scoped=true&"
import script from "./RuglCardInfo.vue?vue&type=script&lang=js&"
export * from "./RuglCardInfo.vue?vue&type=script&lang=js&"
import style0 from "./RuglCardInfo.vue?vue&type=style&index=0&id=4db4ae29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db4ae29",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
